import React from 'react';
import ReactDOM from 'react-dom';

window.axios = require('axios');
window.axios.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const Render = (tagName, Component) => {   
    [...document.getElementsByTagName(tagName)].forEach( dom => {

        let attributesObject = {};
        ([...dom.attributes]).forEach(attr => {
            const tmpAttr = {};
            try {
                tmpAttr[attr.nodeName] = JSON.parse(attr.nodeValue);
            }
            catch(e) {
                tmpAttr[attr.nodeName] = attr.nodeValue;
            }
            attributesObject = {...attributesObject, ...tmpAttr };
        });
        ReactDOM.render(<Component {...attributesObject} />, dom);
    
    });
}

export { Render };